/**
 * Access denied page for users who are authenticated but not in the admin group.
 * Uses Roboticks split-screen layout matching the main app design.
 */

import { Box, Grid, Typography, Button } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useAuth } from '../contexts/AuthContext';

export default function AccessDeniedPage() {
  const { user, logout } = useAuth();

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      {/* Left side - Branding */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 6,
        }}
      >
        <Box sx={{ maxWidth: 450 }}>
          <img
            src="/roboticks-logo.svg"
            alt="Roboticks"
            style={{ height: 48, width: 'auto' }}
          />
          <Typography
            variant="h5"
            sx={{ color: 'white', mt: 4, fontWeight: 500 }}
          >
            Operations Dashboard
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'rgba(255,255,255,0.8)', mt: 2 }}
          >
            Manage deployments, monitor system health, and respond to incidents
            across all Roboticks environments.
          </Typography>
        </Box>
      </Grid>

      {/* Right side - Access Denied */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.paper',
          p: 4,
        }}
      >
        <Box sx={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <BlockIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />

          <Typography variant="h4" fontWeight={600} gutterBottom>
            Access Denied
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            You are signed in as <strong>{user?.email}</strong>, but you don't
            have access to the Ops Dashboard.
          </Typography>

          <Typography variant="body2" color="text.secondary" paragraph>
            Access is restricted.Please contact an
            administrator to request access.
          </Typography>

          <Button variant="contained" onClick={logout} sx={{ mt: 2 }}>
            Sign Out
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
